<p-table
  styleClass="p-datatable-gridlines"
  [value]="atividadeMateriais"
  [scrollable]="true"
  scrollHeight="600px"
  [loading]="loading"
>
  <ng-template pTemplate="header">
    <tr class="font-grid-material-header">
      <th>Item</th>
      <th>Código Material</th>
      <th>Descrição</th>
      <th>Quantidade</th>
      <th>Unidade</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-atividadeMaterial let-i="index">
    <tr class="font-grid-material">
      <td>{{ atividadeMaterial.item }}</td>
      <td>{{ atividadeMaterial.codigoInterno }}</td>
      <td>{{ atividadeMaterial.descricaoMaterial }}</td>
      <td>{{ atividadeMaterial.quantidade }}</td>
      <td>{{ atividadeMaterial.unidadeMaterial }}</td>
    </tr>
  </ng-template>
</p-table>
